import { APICore } from './apiCore';

const api = new APICore();

function GetListPanenPerUnit(params: { perusahaan_id: number; cabang_id?: number }, signal: AbortSignal) {
    return api.get('api/v1/ppic/panen/per-segmentasi', params, { signal });
}

function GetSettingPanen(
    params: {
        perusahaan_id: number;
        cabang_id?: number;
        kategori_bakul_id?: number;
        kategori_panen_id?: number;
        keyword?: string;
        segmentasi?: string;
        page?: number;
        limit?: number;
        tanggal?: string;
    },
    signal?: AbortSignal
) {
    return api.get('api/v1/ppic/panen/setting-panen', params, { signal });
}

function editSettingPanen(payload: {
    setting_kontrak_id: number;
    data: {
        setting_kontrak_id: number;
        perusahaan_id: number;
        cabang_id: number;
        peternak_id: number;
        periode: number;
        kategori_panen_id: number;
        kategori_panen_label: string;
        tanggal_chick_in: string;
        tanggal_panen: string;
        umur: number;
        bw: number;
        persentase: number;
        ekor: number;
        tonase: number;
        rit: number;
        kategori_bakul_id: null;
        populasi_chick_in: number;
    }[];
}) {
    return api.create('/api/v1/ppic/panen/setting-panen', payload);
}

export { GetSettingPanen, editSettingPanen, GetListPanenPerUnit };
